import createSource from './createSource';
import { SCREEN_PRESENTER } from '@shoflo/polymer';
import { selectLastPresenterSource } from 'selectors/broadcastSourcesSelector';
import { UNASSIGNED } from 'utils/broadcastSourceHelper';
export default number => {
  return (dispatch, getState) => {
    const state = getState();
    let { order: lastPresenterOrder = 0 } = selectLastPresenterSource(state);

    const order = lastPresenterOrder ? lastPresenterOrder + 1 : 0;
    dispatch(
      createSource({
        title: `Screen ${number}`,
        type: SCREEN_PRESENTER,
        value: UNASSIGNED,
        order
      })
    );
  };
};
